export const FIXING_TIME = [
  { id: '13:15_SAO_PAULO', displayValue: '13:15 São Paulo' },
  { id: '15:00_PARIS_FRANKFURT', displayValue: '15:00 Paris/Frankfurt' },
  { id: '15:00_TOKYO', displayValue: '15:00 Tokyo' },
  { id: '15:00_LONDON', displayValue: '15:00 London' },
  { id: '16:00_LONDON', displayValue: '16:00 London' },
  { id: '16:00_NEW_YORK', displayValue: '16:00 New York' },
  { id: '16:00_WMR', displayValue: '16:00 WMR' },
  { id: '17:00_TOKYO', displayValue: '17:00 Tokyo' },
];
